export const fr = {
  pollingForm: {
    titles: {
      placeVote: 'Placez votre vote',
      voteResults: 'Résultats du vote',
      noCharitiesNominated: 'Aucun organisme de bienfaisance nominé pour le moment'
    },
    descriptions: {
      hoverForDetails: 'Survolez pour les détails',
      checkBackSoon: 'Revenez bientôt pour voter et aider à diriger les fonds vers la communauté !',
      lastQuarterWinners: 'Les gagnants du dernier trimestre :'
    },
    buttons: {
      voteForCharity: 'Voter pour un organisme de bienfaisance'
    },
    pagination: {
      pageOf: 'Page {{current}} sur {{total}}'
    },
    validation: {
      required: 'Requis.'
    },
    alerts: {
      choiceSubmitted: 'Choix soumis avec succès'
    }
  }
}